import { DiagnosticsData } from '../../../shared/types/diagnosticsData.ts';
import { formatDuration, formatLatestData } from '../../utils/fieldFormats.ts';
import { getStatusMarker } from '../../utils/getStatusMarker.ts';


interface Props {
    diagnosticsResults: DiagnosticsData;
    style?: React.CSSProperties;
}

export function DiagnosticsTable({
    diagnosticsResults,
    style,
}: Props) {
    return (
        <table style={{ ...style, width: '1080px' }}>
            <tbody>
                <tr>
                    <td />
                    <td>Server uptime</td>
                    <td>{formatDuration(diagnosticsResults.serverUptime, true, false)}</td>
                </tr>
                <tr>
                    <td>{getStatusMarker(diagnosticsResults.startupCompleteStatus)}</td>
                    <td>Startup complete</td>
                    <td>{diagnosticsResults.startupComplete ? 'True' : 'False'}</td>
                </tr>
                <tr>
                    <td>{getStatusMarker(diagnosticsResults.dbLatencyStatus)}</td>
                    <td>Database latency</td>
                    <td>{diagnosticsResults.dbLatency
                        ? diagnosticsResults.dbLatency + 'ms'
                        : ''
                    }</td>
                </tr>
                <tr>
                    <td>{getStatusMarker(diagnosticsResults.mtLinkiPingStatus)}</td>
                    <td>MT-LINKi server</td>
                    <td>{diagnosticsResults.mtLinkiPingMessage}</td>
                </tr>
                <tr>
                    <td>{getStatusMarker(diagnosticsResults.mtLinkiApiStatus)}</td>
                    <td>MT-LINKi API</td>
                    <td>{diagnosticsResults.mtLinkiApiMessage}</td>
                </tr>
                <tr>
                    <td>{getStatusMarker(diagnosticsResults.mtLinkiSpeedStatus)}</td>
                    <td>MT-LINKi response time</td>
                    <td>{
                        diagnosticsResults.mtLinkiSpeedTimingOut ? 'Timing out'
                            : !diagnosticsResults.mtLinkiSpeedAvgTime ? 'No data'
                                : formatDuration(diagnosticsResults.mtLinkiSpeedAvgTime!, false, true)
                    }</td>
                </tr>
                <tr>
                    <td>{getStatusMarker(diagnosticsResults.preloadedUpdateStatus)}</td>
                    <td>Data update period</td>
                    <td>{
                        diagnosticsResults.preloadedUpdatePeriod
                            ? formatDuration(diagnosticsResults.preloadedUpdatePeriod, false, true)
                            : 'No data'
                    }</td>
                </tr>
                <tr>
                    <td>{getStatusMarker(diagnosticsResults.preloadedUpdateStatus)}</td>
                    <td>Latest data update</td>
                    <td>{
                        diagnosticsResults.latestPreloadedUpdate
                            ? formatLatestData(diagnosticsResults.latestPreloadedUpdate)
                            : 'No data'
                    }</td>
                </tr>
                <tr>
                    <td colSpan={3}>{diagnosticsResults.conclusion}</td>
                </tr>
            </tbody>
        </table>
    );
}
